import React from 'react'

import './style.scss'
import TeamItem from './TeamItem';
import 'swiper/css';


import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, SwiperOptions } from "swiper";

// {
//         name: "Eldric",
//         label: "Wanderer of the Quiet Realms",
//         src: "assets/img/avatar/eldric.jpg",
//         description: `"I have walked beneath forgotten skies and mapped the silence between stars. I dwell where the river turns back on itself."`
//     },
//     {
//         name: "Seraphine",
//         label: "Keeper of the Windless Chimes",
//         src: "assets/img/avatar/seraphine.jpg",
//         description: `"I guard the path where bells ring without wind. If you hear them, you are already close."`
//     },
//     {
//         name: "Elandor",
//         label: "Last Son of Stonewatch",
//         src: "assets/img/avatar/elandor.jpg",
//         description: `"I was forged in mountain shadow. I trust stone, silence, and the strength of what endures."`
//     },
//     {
//         name: "Lyra",
//         label: "Daughter of the Sapphire Sky",
//         src: "assets/img/avatar/lyra.jpg",
//         description: `"I speak softly so the stars may answer. Light follows where I choose to walk."`
//     }

const TeamDetails = [
    {
        src: "assets/img/avatar/eldric.jpg",
        title: "Eldric",
        subTitle: "Wanderer of the Quiet Realms",
    },
    {
        src: "assets/img/avatar/seraphine.jpg",
        title: "Seraphine",
        subTitle: "Keeper of the Windless Chimes",
    },
    {
        src: "assets/img/avatar/elandor.jpg",
        title: "Elandor",
        subTitle: "Last Son of Stonewatch",
    },
    {
        src: "assets/img/avatar/lyra.jpg",
        title: "Lyra",
        subTitle: "Daughter of the Sapphire Sky",
    }

]


const Team = ({ className, desktop, mobile, tablet, ...restProps }: SwiperOptions) => {
    return (
        <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true, el: '.swiper-pagination' }}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
                992: desktop,
                768: tablet,
                576: mobile
            }}
            className={`dsn-team ${className || ''}`}
            {...restProps}
        >
            {TeamDetails.map((item, index) =>
                <SwiperSlide key={index}>
                    <TeamItem src={item.src} title={item.title} subTitle={item.subTitle} />
                </SwiperSlide>
            )}
            <div className="swiper-pagination" />
        </Swiper>
    );
}

Team.defaultProps = {
    desktop: {
        slidesPerView: 2.5
    },
    tablet: {
        slidesPerView: 2

    },
    mobile: {
        slidesPerView: 2
    }
}

export default Team
